import { getHTML } from "../../services/helper";

interface IProps {
  blockClass?: string;
  content: {
    header?: string;
    items?: {
      iconClass?: string;
      header?: string;
      description?: string;
    }[];
  };
}

const ContentBlock: React.FC<IProps> = (props: IProps) => {
  return (
    <div id="content-block">
      {props.content.header && (
        <h2 className="font-weight-extra-light border-bottom-1px pb-2 mb-4">{props.content.header}</h2>
      )}
      <div className="row no-gutters">
        {props.content.items &&
          props.content.items.length > 0 &&
          props.content.items.map((item, index) => (
            <div key={index} className="col-sm-12 col-md-4 col-lg-3 p-2">
              <div className={"card-block h-100 " + props.blockClass}>
                <h5 className="h5 my-2">
                  <i className={"mb-3 fa-2x " + item?.iconClass}></i>
                  <div
                    dangerouslySetInnerHTML={getHTML(item.header || "")}
                  ></div>
                </h5>
                <p
                  className="text-muted"
                  dangerouslySetInnerHTML={getHTML(item.description || "")}
                ></p>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ContentBlock;
